module.exports = __webpack_public_path__ + "img/aerospace-careers.77c3c572.jpg";